import './MNTN.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class MNTN extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
